import { RegistriaSnippetResponse } from './registria-snippet-response.interface';

export type RegistriaUserResponse = {
  snippet_data?: RegistriaSnippetResponse;
};
